/*
 * Uploader App Panel Template
 *
 * Includes:
 * - Transfer Sheet
 * - Grid View
 * - Asset Viewer
 */
import type {
  PanelsBreakpointTemplate,
  PanelsTemplate,
  UploaderAppPanelArea,
} from '../types';
import {
  LARGE_NAV_DEFAULT_WIDTH,
  MEDIUM_NAV_MAX_WIDTH,
  MEDIUM_NAV_MIN_WIDTH,
} from './constants';
import TEXT from './generated/TEXT/uploaderApp';

TEXT.DEFINE({
  directoryNav: {
    accessibility: 'Toggle the Transfer Sheet',
    hide: 'Hide',
    show: 'Show',
  },
  viewer: {
    accessibility: 'Toggle the Asset Viewer',
    hide: 'Hide Asset Viewer',
    show: 'Show Asset Viewer',
  },
});

/**
 * This template does not need to take into consideration different viewports.
 */
export const baseTemplate = (): PanelsBreakpointTemplate => {
  return {
    areas: [['directoryNav', 'directoryContent', 'viewer']],
    resizers: {
      directoryNav: 'right',
      directoryContent: 'right',
      viewer: 'right',
    },
    columns: [
      /* Transfer Sheet */
      {
        key: 'directoryNav',
        defaultMin: MEDIUM_NAV_MIN_WIDTH,
        defaultSize: LARGE_NAV_DEFAULT_WIDTH,
        defaultMax: MEDIUM_NAV_MAX_WIDTH,
        isToggleable: true,
        panelToggle: {
          variant: 'left',
          label: TEXT.directoryNav,
        },
        showing: true,
      },

      /* Assets */
      {
        key: 'directoryContent',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
        showing: true,
      },

      /* Viewer Panel */
      {
        key: 'viewer',
        defaultMin: 376,
        defaultSize: '1fr',
        isToggleable: true,
        panelToggle: {
          variant: 'center',
          label: TEXT.viewer,
        },
        showing: false,
      },
    ],
    rows: [
      {
        key: 'defaultRow',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
};

export function mediumTemplate() {
  return baseTemplate();
}

export function largeTemplate() {
  return baseTemplate();
}

export function getPanelState(): PanelsTemplate {
  return {
    base: baseTemplate(),
    tablet: baseTemplate(),
    desktop: baseTemplate(),
    visible: getDefaultVisiblePanels(),
  };
}

export const getDefaultVisiblePanels = (): Array<UploaderAppPanelArea> => {
  return ['directoryNav', 'directoryContent', 'viewer'];
};

export const getDefaultPanelState = (): PanelsTemplate => {
  return getPanelState();
};
